export * from "./capitalize.pipe";
export * from "./plural.pipe";
export * from "./round.pipe";
export * from "./timing.pipe";
export * from "./number-with-commas.pipe";
